import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AdminFundPoolSummary, AdminFundTransaction, ApiService } from '../../core/api.service';

@Component({
  selector: 'ch-fund-pool',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './fund-pool.component.html'
})
export class FundPoolComponent implements OnInit {
  summary: AdminFundPoolSummary | null = null;
  direction = 'credit';
  amount = 0;
  narration = '';
  loading = false;
  saving = false;
  error = '';
  notice = '';

  constructor(private readonly api: ApiService) {}

  ngOnInit(): void {
    this.load();
  }

  async load(): Promise<void> {
    this.loading = true;
    this.error = '';
    try {
      this.summary = await this.api.adminFundPool();
    } catch {
      this.error = 'Could not load admin fund pool.';
    } finally {
      this.loading = false;
    }
  }

  async submit(): Promise<void> {
    if (this.saving || this.amount <= 0) return;
    this.saving = true;
    this.error = '';
    this.notice = '';
    try {
      this.summary = await this.api.adminFundPoolAction({
        direction: this.direction,
        amount_cents: Math.round(Number(this.amount || 0) * 100),
        narration: this.narration.trim()
      });
      this.notice = `Fund pool ${this.direction === 'credit' ? 'credited' : 'debited'}.`;
      this.amount = 0;
      this.narration = '';
    } catch (error) {
      this.error = error instanceof Error ? error.message : 'Could not update fund pool.';
    } finally {
      this.saving = false;
    }
  }

  money(cents: number | undefined): string {
    return `KSh ${Math.round((cents || 0) / 100).toLocaleString()}`;
  }

  signedAmount(tx: AdminFundTransaction): string {
    const sign = tx.direction === 'credit' ? '+' : '-';
    return `${sign}${this.money(tx.amount_cents)}`;
  }
}
